import { useEffect, useContext, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { NavBar } from "../NavBar";
import { FaPlus } from "react-icons/fa";
import { RiLogoutCircleLine } from "react-icons/ri";
import "@fontsource/bangers";

import { AuthContext, AuthContextType } from "../../context";

export function Layout() {
  const { logout } = useContext(AuthContext) as AuthContextType;

  const isUserLoggedIn = localStorage.getItem("currentUser");

  const [hidden, setHidden] = useState(false);

  const isMobile = window.innerWidth <= 425;

  const location = useLocation();
  useEffect(() => {
    if (location.pathname !== "/Create") return setHidden(false);
    setHidden(true);
  }, [location]);

  return (
    <section>
      {isMobile ? (
        <>
          <div className="flex flex-col h-[100vh] bg-zinc-100 dark:bg-chinBlackDark">
            <header className="h-16 fixed w-screen z-50 flex justify-center items-center bg-white dark:bg-eerieBlack">
              {isUserLoggedIn && (
                <div className="fixed top-0 left-0 m-3">
                  <button
                    className="h-10 w-10 text-3xl border border-black dark:border-white text-black dark:text-white rounded-xl p-1"
                    onClick={logout}
                  >
                    <RiLogoutCircleLine />
                  </button>
                </div>
              )}
              <div className="flex text-5xl">
                <p className="font-['bangers'] text-lustRed">24</p>
                <p className="font-['bangers'] text-eerieBlack dark:text-white">Grind</p>
              </div>
              <div className="fixed top-0 right-0 m-3">
                <Link to="/Create">
                  <button
                    className="w-10 text-3xl border border-black dark:border-white text-black dark:text-white rounded-xl p-1"
                    hidden={hidden}
                  >
                    <FaPlus />
                  </button>
                </Link>
              </div>
            </header>
            <main className="mb-auto my-16 pb-5 overflow-scroll">
              <div>
                <Outlet />
              </div>
            </main>
            <div className="">
              <NavBar />
            </div>
          </div>
        </>
      ) : (
        <section className="ml-5 p-5 bg-slate-600 w-96 text-white rounded-lg">
          <h1>Desktop Version Coming Soon!</h1>
          <p>To check the Mobile version</p>
          <br />
          <p>1. Right click and Click on Inspect</p>
          <br />
          <p>2. Click on Mobile device Toolbar</p>
          <img src="images/mobile-toolbar.png" alt="mobile-toolbar" />
          <br />
          <p>3. Select between Mobile version S, M or L width </p>
          <img src="images/Mobile-widthVersion.png" alt="widthVersion" />
          <br />
          <p>4. Refresh</p>
          <br />
          <p>Note: This is a Proof of Concept, still in development.</p>
        </section>
      )}
    </section>
  );
}
